
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/accessibility",
      function () {
        return require("private-next-pages/accessibility.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/accessibility"])
      });
    }
  